import { FETCH_DYNAMIC_TARGETING_KEYS } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";

import { fetchDynamicTargetingKeysService } from "../../services/dcm/dynamicTargetingKeys";
import { setAuthError } from "../app/global";

const beginFetchDynamicTargetingKeys = () => ({
  type: FETCH_DYNAMIC_TARGETING_KEYS,
  status: PENDING
});

const successDynamicTargetingKeys = dynamicTargetingKeys => ({
  type: FETCH_DYNAMIC_TARGETING_KEYS,
  status: SUCCESS,
  data: dynamicTargetingKeys
});

const failureDynamicTargetingKeys = err => ({
  type: FETCH_DYNAMIC_TARGETING_KEYS,
  status: FAILURE,
  err
});

export const fetchDynamicTargetingKeys = advertiserId => {
  return async dispatch => {
    dispatch(beginFetchDynamicTargetingKeys());

    try {
      const dynamicTargetingKeys = await fetchDynamicTargetingKeysService(advertiserId);

      dispatch(successDynamicTargetingKeys(dynamicTargetingKeys));
    } catch (e) {
      if (e.message === "UNAUTHORIZED") {
        dispatch(setAuthError());
        return;
      }

      dispatch(failureDynamicTargetingKeys(e));
    }
  };
};
